import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-video-view-popup',
  templateUrl: './video-view-popup.component.html',
  styleUrls: ['./video-view-popup.component.css']
})
export class VideoViewPopupComponent implements OnInit {
  @Input() videoData: any;
  public safeVideoValue: any;
  constructor(public activeModal: NgbActiveModal, public sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.safeVideoValue = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoData?.VideoLink + "?wmode=transparent&amp;rel=0");
  }
  closeVideoPreview() {
    this.activeModal.close(false);
  }
  startEditing() {
    this.activeModal.close(true);
  }
}
